import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBusinessTypes, deleteBusinessType, changeActiveStatus } from './businessTypeSlice';
import { Container, Modal, Toast, Button } from "react-bootstrap";
import Input from "../../components/input";
import { useNavigate } from "react-router-dom";
import CommonButton from "../../components/commonButton";
import CommonPagination from "../../components/commonPagination";
import CommonTable from '../../components/commonTable';
import { Add01Icon } from "../../assets/icons";
import { useLoader } from "../../context/LoaderContext";

const BusinessTypeList = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const { businessTypes } = useSelector((state) => state.businessTypes);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedBusinessTypeId, setSelectedBusinessTypeId] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const limit = 10;
  const totalPages = Math.ceil(businessTypes?.total_records / limit);
  const total = businessTypes?.total_records || 0;

  const token = localStorage.getItem('admin-auth-token');

  let businessTypeMessage = localStorage.getItem('business_type_notify_message');

  useEffect(() => {
    if (businessTypeMessage) {
      setSnackbarMessage(businessTypeMessage);
      setSnackbarVariant("success");
      setShowSnackbar(true);
      localStorage.removeItem('business_type_notify_message');
    }
  }, [businessTypeMessage])

  useEffect(() => {
    const fetchBusinessTypes = async () => {
      setLoading(true);
      const payload = {
        page: currentPage,
        search: searchTerm,
        limit: limit,
        token
      };
  
      try {
        if (token) {
          await dispatch(getBusinessTypes({ payload }));
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching business types:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchBusinessTypes();
  }, [dispatch, token, currentPage, searchTerm, setLoading]);
  

  const columns = [
    { label: 'Name', key: 'name' },
    { label: 'created at', key: 'created_at', type: 'date' },
    {label: 'Status', key: 'is_active', type: 'status' },
  ];

  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber);
  };

  const handleDeleteNew = async () => {
    if (selectedBusinessTypeId) {
      await dispatch(deleteBusinessType(selectedBusinessTypeId)).then((res) => {
        if(res.payload.success) {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          const payload = {
            page: currentPage,
            search: searchTerm,
            limit: limit,
            token
          };
          dispatch(getBusinessTypes({ payload }));
        } else {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("danger");
          setShowSnackbar(true);
        }
      });
    }
  };

  const handleEdit = (row) => {
    navigate(`/business-type-edit/${row.id}`);
  };
  

  const handleDelete = (row) => {
    setSelectedBusinessTypeId(row.id);
    setShowDeleteModal(true);
  };

  const handleView = (row) => {
    setSelectedBusinessTypeId(row.id);
  };

  const handleStatusChange = async (row) => {
    setSelectedBusinessTypeId(row.id);
    setShowStatusModal(true);
  }

  const handleStatusChangeNew = async () => {
    await dispatch(changeActiveStatus(selectedBusinessTypeId)).then((res) => {
      if(res.payload.success) {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("success");
        setShowSnackbar(true);
        const payload = {
          page: currentPage,
          search: searchTerm,
          limit: limit,
          token
        };
        dispatch(getBusinessTypes({ payload }));
      } else {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      }
    });
  }

  return (
    <>
      <Container fluid className="px-0">
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this Business Type?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDeleteNew}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Status Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to change status?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowStatusModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleStatusChangeNew}>
              Change
            </Button>
          </Modal.Footer>
        </Modal>

        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
          style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
        >
          <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
        </Toast>

        <div className="p-4 d-flex align-items-center justify-content-between gap-4">
          <Input
            type="search"
            value={searchTerm}
            placeholder="Search Business Type"
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            className="shadow-none base-search"
          />

          <CommonButton
            icon={<Add01Icon width={16} height={16} color="#ffffff" strokeWidth="2" />}
            title="Add Business Type"
            className="btn-primary common-one-shadow"
            onClick={() => {
              navigate("/business-type-add");
            }}
          />
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow">
            <CommonTable
              columns={columns}
              data={businessTypes?.data || []}
              url={businessTypes?.url || []}
              showActions={true}
              actions={{
                showEdit: true,
                showDelete: true,
                showView: false,
                onEdit: handleEdit,
                onDelete: handleDelete,
                onView: handleView
              }}
              onStatusChange={handleStatusChange}
            />
        </div>

        <div className="p-3 mx-1 d-flex flex-wrap align-items-center justify-content-between gap-4">
          <p className="custom-table-infotext">
            Displaying {(limit * (currentPage - 1)) + 1} to {Math.min(limit * currentPage, total)} of {total} Business Types
          </p>

          <div>
            {totalPages > 1 ? (
              <CommonPagination
                totalItems={total}
                itemsPerPage={limit}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            ) : null}
          </div>
        </div>
      </Container>
    </>
  );
};

export default BusinessTypeList;
